import { Pipe, PipeTransform } from '@angular/core';
import { StatusEnum } from '../../common/constants/status-enum';

@Pipe({
  name: 'statusTranform'
})
export class StatusTranformPipe implements PipeTransform {

  private statusStylesMap: {
      [key in StatusEnum]?: { color: string; backgroundColor: string };
    } = {
      [StatusEnum.NCANeverStarted]: {
        color: '#808080',
        backgroundColor: '#f0f0f0',
      },
      [StatusEnum.NCAInProgress]: {
        color: '#808080',
        backgroundColor: '#f7f7f7',
      },
      [StatusEnum.NCAApprovedWithConditions]: {
        color: '#FFA500',
        backgroundColor: '#fff4e6',
      },
      [StatusEnum.NCAApprovedUpToDate]: {
        color: '#008000',
        backgroundColor: '#e6ffe6',
      },
      [StatusEnum.NCAApprovedPending]: {
        color: '#008000',
        backgroundColor: '#e6ffe6',
      },
      [StatusEnum.ContinuanceExpired]: {
        color: '#FF0000',
        backgroundColor: '#ffe6e6',
      },
      [StatusEnum.DoNotServe]: { color: '#FF0000', backgroundColor: '#ffe6e6' },
      [StatusEnum.NCAOnHold]: { color: '#808080', backgroundColor: '#f0f0f0' },
      [StatusEnum.NCADeFactoAccepted]: {
        color: '#008000',
        backgroundColor: '#e6ffe6',
      },
      [StatusEnum.Pending]: { color: '#FFA500', backgroundColor: '#fff4e6' },
      [StatusEnum.RMReviewed]: { color: '#008000', backgroundColor: '#e6ffe6' },
      [StatusEnum.Draft]: { color: '#63666a', backgroundColor: '#F2F2F2' },
      [StatusEnum.Submitted]: { color: '#007CB0', backgroundColor: '#EEF9FF' },
      [StatusEnum.RM_REVIEWED_PENDING_CLOSEOUT ]: { color: '#008000', backgroundColor: '#e6ffe6' },
      [StatusEnum.SELF_REVIEWED_PENDING_CLOSEOUT ]: { color: '#008000', backgroundColor: '#e6ffe6' },
      [StatusEnum.RETURN_FOR_REWORK]: { color: '#FF0000', backgroundColor: '#ffe6e6' },
      [StatusEnum.RESUBMITTED]: {color: '#FF0000', backgroundColor: '#ffe6e6'},
      [StatusEnum.COMPLETED]: {color: '#63666a', backgroundColor: '#F2F2F2'},
      [StatusEnum.Pending_approvals]: {color: '#007cb0', backgroundColor: '#eef9ff'},
      [StatusEnum.DISCONTINUED]: {color: '#007cb0', backgroundColor: '#eef9ff'},
      [StatusEnum.Accepted]: {color: '#26890d', backgroundColor: '#43b02a14'},
      [StatusEnum.Serve_with_conditions]: {color: '#ed8b00', backgroundColor: '#ed8b0014'},
      [StatusEnum.On_Hold]: { color: '#808080', backgroundColor: '#f0f0f0' },
      [StatusEnum.Declined]: {color: '#007cb0', backgroundColor: '#eef9ff'},
      [StatusEnum.In_process]: {color: '#007cb0', backgroundColor: '#eef9ff'},
      [StatusEnum.Due_Now]: {color: '#007cb0', backgroundColor: '#eef9ff'},
      [StatusEnum.NCA_Not_required_accepted]: {color: '#007cb0', backgroundColor: '#eef9ff'},
      [StatusEnum.RecentApprovalDoNotServe]: { color: '#da291c', backgroundColor: '#fceeed' },
    };
  
    transform(
      status: StatusEnum,
      styleType: 'color' | 'backgroundColor'
    ): string {
      return (
        this.statusStylesMap[status]?.[styleType] ||
        (styleType === 'color' ? '#000000' : 'transparent')
      );
    }

}
